<script setup>
// [xleaders] XO-12: reaction của khách (Zalo cá nhân) dính vào góc dưới phía trong của bong bóng —
// góc ngoài là góc "đuôi" (bo nhỏ) nên dùng góc đối diện, như Messenger/Zalo. Chỉ một icon, không đếm.
// Nằm TRONG bong bóng (không nhô ra) vì bubble ảnh/video/file đặt `overflow-hidden` lên root;
// Base.vue chừa `pb-6` (đè lên `py-3` của bubble chữ) để badge không đè lên chữ hay giờ gửi.
import { computed } from 'vue';
import { ORIENTATION } from '../constants';

const props = defineProps({
  icon: { type: String, required: true },
  orientation: { type: String, default: ORIENTATION.LEFT },
});

const cornerClass = computed(() =>
  props.orientation === ORIENTATION.RIGHT
    ? 'ltr:left-2 rtl:right-2'
    : 'ltr:right-2 rtl:left-2'
);
</script>

<template>
  <span
    data-test-id="zalo-reaction-badge"
    class="absolute bottom-1 px-1 text-xs leading-4 rounded-full select-none bg-n-background outline outline-1 outline-n-weak shadow-sm"
    :class="cornerClass"
  >
    {{ icon }}
  </span>
</template>
